module.exports = __webpack_public_path__ + "static/media/creator-swoosh.2ff78c3d.png";